module.exports = __webpack_public_path__ + "media/luxury-2026/stone-living-960-5ff9490f.jpg";